export default {
  // --- App / global ---
  app_name: 'SwipeWish TCG',
  ok: 'OK',
  cancel: 'Annulla',
  save: 'Salva',
  back: 'Indietro',
  loading: 'Caricamento',
  error_generic: 'Si è verificato un errore',
  retry: 'Riprova',

  // --- Auth ---
  auth_sign_in: 'Accedi',
  auth_sign_up: 'Registrati',
  auth_email: 'Email',
  auth_password: 'Password',
  auth_username: 'Username',
  auth_username_min: 'Username minimo 3 caratteri',
  auth_username_max: 'Username massimo 20 caratteri',
  auth_submit_login: 'Accedi',
  auth_submit_register: 'Registrati',
  auth_tagline: 'Trova carte, scambia con chi ti sta vicino.',
  auth_confirm_email: 'Account creato. Controlla la tua email per la conferma, poi accedi. Se non trovi la mail, verifica nello spam.',
  auth_error: 'Errore di autenticazione',
  auth_show_password: 'Mostra password',
  auth_hide_password: 'Nascondi password',
  auth_or_continue_with: 'oppure continua con',
  auth_google: 'Google',
  auth_facebook: 'Facebook',
  auth_first_name: 'Nome',
  auth_last_name: 'Cognome',
  auth_first_name_required: 'Il nome è obbligatorio',
  auth_last_name_required: 'Il cognome è obbligatorio',
  auth_disallowed_words_field: 'Il campo "{field}" contiene parole non ammesse',
  auth_address: 'Indirizzo',
  auth_address_placeholder: 'Cerca via, città, CAP',
  auth_address_hint: 'Utilizzato solo per calcolare distanze approssimative.',
  auth_callback_loading: 'Accesso in corso…',
  auth_callback_redirect_login: 'Reindirizzamento al login…',

  // --- Tabs ---
  tab_discover: 'Scopri',
  tab_inventory: 'Collezione',
  tab_wishlist: 'Wishlist',
  tab_matches: 'Match',
  tab_profile: 'Profilo',

  // --- Swipe ---
  swipe_set_location_title: 'Imposta la tua posizione',
  swipe_set_location_desc: 'Mostriamo solo distanze approssimative. La tua posizione esatta non viene mai salvata.',
  swipe_enable_geo: 'Abilita geolocalizzazione',
  swipe_searching: 'Cerco carte vicine a te',
  swipe_resolving_location: 'Aggiorno la tua posizione…',
  swipe_empty_title: 'Nessuna carta nei dintorni',
  swipe_empty_desc: 'Non ci sono carte da scoprire entro il tuo raggio attuale ({radius} km). Prova ad ampliarlo tramite l\'icona in alto a destra o controlla più tardi.',
  swipe_edit_radius: 'Modifica raggio',
  swipe_filters_button: 'Filtri',
  swipe_filters_title: 'Filtri abbinamenti',
  swipe_filters_any: 'Qualsiasi',
  swipe_filters_requested_only_hint: 'I filtri vengono applicati alle carte richieste (wishlist) dei candidati.',
  swipe_filters_rarity: 'Rarità',
  swipe_filters_condition: 'Condizione carta',
  swipe_filters_language: 'Lingua',
  swipe_filters_grading_company: 'Casa gradazione',
  swipe_filters_grade: 'Voto',
  swipe_filters_rarity_disabled_multi_tcg: 'Rarità disattivata: disabilita "Ricerca abbinamenti combinati" nelle Impostazioni per riattivarla.',
  swipe_outgoing_match_pending_warning: 'Hai match inviati in corso: le carte della wishlist già presenti in quei match non generano nuovi abbinamenti finché la trattativa non si chiude o viene annullata.',
  swipe_free_active_match_cap_warning: 'Raggiunto il numero massimo di 4 match attivi',
  swipe_location_block_title: 'Posizione non disponibile',
  swipe_location_block_desc: 'Geolocalizzazione non attiva o Indirizzo non indicato.',
  swipe_go_to_settings: 'Vai a Impostazioni',
  swipe_slot_block_title: 'Limite slot superato',
  swipe_slot_block_desc: "Limite slot superato, attivare l'abbonamento Pro o ridurre le quantità nell'inventario e nella wishlist.",
  offline_title: 'Connessione non disponibile',
  offline_no_connection: 'Connessione ad Internet assente, impossibile accedere alle funzionalità della piattaforma.',

  // --- Match popup ---
  match_title: "C'è un match!",
  match_subtitle: 'A te e <strong>{username}</strong> interessano le rispettive carte. Iniziate a chattare per organizzare lo scambio.',
  match_chat: 'Apri match',
  match_continue: 'Continua a swipare',
  match_already_title: 'Sei stato appena matchato',
  match_already_subtitle: '<strong>{username}</strong> ha appena creato un match con te. Apri la sezione dei match ricevuti per continuare.',
  match_open_incoming: 'Apri match ricevuti',
  match_cards_count: '{count} carte in comune',
  match_tap_to_view: 'Tocca una carta per i dettagli',
  match_back_to_cards: 'Torna alle carte',

  // --- Inventory ---
  inv_title: 'Il mio album',
  inv_slots: '{used}/{total} slot usati',
  inv_slots_unlimited: '{used} slot usati',
  inv_go_pro: 'Passa a Pro',
  inv_empty_title: 'Il tuo raccoglitore è vuoto',
  inv_empty_desc: 'Aggiungi le tue carte per iniziare a scambiarle.',
  inv_add: 'Aggiungi carte',
  inv_not_tradeable: 'Non scambiabile',
  inv_match_locked_warning: 'Carta in un match attivo',

  // --- Wishlist ---
  wish_title: 'Wishlist',
  wish_empty_title: 'La tua wishlist è vuota',
  wish_empty_desc: 'Salva le carte che cerchi per ricevere migliori suggerimenti negli swipe.',
  wish_add: 'Aggiungi carte',

  // --- Catalog ---
  catalog_title: 'Catalogo carte',
  catalog_search: 'Cerca per nome',
  catalog_results: '{count} risultati',
  catalog_binder: 'Album',
  catalog_wishlist: 'Wishlist',
  catalog_add: 'Aggiungi',
  catalog_added_label: 'Aggiunta',
  catalog_remove: 'Rimuovi',
  catalog_added_binder: '"{name}" aggiunta all\'album',
  catalog_added_wish: '"{name}" aggiunta alla wishlist',
  catalog_select_tcg: 'Seleziona TCG',

  // --- Matches / Chat ---
  matches_title: 'I tuoi match',
  matches_empty_title: 'Nessun match effettuato',
  matches_empty_desc: 'Vai nella sezione Scopri per fare un match con altri utenti!',
  matches_section_outgoing: 'Match inviati',
  matches_section_incoming: 'Match in arrivo',
  history_matches_section_outgoing: 'Match inviati completati',
  history_matches_section_incoming: 'Match in arrivo completati',
  matches_unread_label: '{count} messaggi non letti',
  chat_placeholder: 'Scrivi un messaggio…',
  matches_confirm: 'Conferma',
  matches_load_error: 'Impossibile caricare i match. Controlla la connessione e riprova.',
  matches_load_error_title: 'Errore caricamento match',
  matches_load_retry: 'Riprova caricamento',
  chat_unavailable: 'Impossibile inviare: match non valido o sessione scaduta.',
  chat_attachment_unsupported: 'Formato allegato non supportato.',
  chat_attachment_too_large: 'Il file supera il limite di 5 MB.',
  chat_uploading: 'Caricamento allegato…',

  // --- Notifications ---
  notifications_title: 'Notifiche',
  notifications_empty: 'Nessuna nuova notifica',
  notification_new_match: 'Hai un nuovo match',
  notification_new_message: 'Nuovo messaggio',
  notification_image: 'Immagine',
  notification_trade_proposed: 'Vuole scambiare con te',
  notification_trade_accepted: 'Ha accettato lo scambio',
  notification_trade_cancelled: 'Scambio annullato',
  notification_review_prompt: 'Lascia una recensione sullo scambio appena concluso',
  notifications_view_title: 'Centro notifiche',
  notifications_push_badge_title: 'Notifiche push disattivate',
  notifications_push_badge_desc: 'Attiva le notifiche push per ricevere subito nuovi match e messaggi.',
  notifications_push_activate: 'Attiva',
  notifications_push_activating: 'Attivazione…',
  notifications_push_enabled: 'Notifiche push attivate.',
  notifications_push_enable_error: 'Impossibile attivare le notifiche push.',

  // --- Reviews ---
  reviews_button: 'Recensioni',
  history_leave_review_btn: 'Lascia recensione',
  reviews_modal_title: 'Recensioni di {user}',
  reviews_empty: 'Nessuna recensione ancora.',
  reviews_count: '{count} recensioni',
  review_form_title_outgoing: 'Recensisci {user}',
  review_form_title_incoming: 'Recensisci {user}',
  review_form_rating_label: 'Voto',
  review_form_comment_label: 'Commento',
  review_form_comment_placeholder: 'Scrivi un commento (facoltativo)',
  review_form_submit: 'Invia',
  review_form_cancel: 'Annulla',

  // --- Profile ---
  profile_title: 'Profilo',
  profile_display_name: 'Nome visualizzato',
  profile_bio: 'Bio',
  profile_save: 'Salva profilo',
  profile_saved: 'Profilo aggiornato',
  profile_settings: 'Impostazioni',
  profile_help: 'Guida',
  profile_location: 'Posizione',
  profile_logout: 'Esci',
  profile_info_section: 'Informazioni profilo',
  profile_other_section: 'Altro',
  profile_change_photo: 'Cambia foto',
  profile_avatar_alt: 'Avatar profilo',

  // --- Help ---
  help_hero_desc: 'La piattaforma pensata per collezionisti di carte TCG che vogliono scambiare in modo sicuro, diretto e senza complicazioni.',
  help_in_person_title: 'Perché scambiare di persona?',
  help_in_person_desc: 'Le spedizioni portano rischi reali: carte danneggiate in transito, smarrimenti, truffe difficili da contestare. SwipeWish nasce proprio per eliminarli.',
  help_in_person_transport_title: 'Zero rischi di trasporto',
  help_in_person_transport_desc: 'vedi le carte dal vivo prima di darle, nessuna sorpresa.',
  help_in_person_direct_title: 'Scambio diretto tra collezionisti',
  help_in_person_direct_desc: 'nessun intermediario, nessuna piattaforma di pagamento, nessuna commissione.',
  help_in_person_mutual_title: 'Vantaggio reciproco garantito',
  help_in_person_mutual_desc: 'un match appare solo se entrambi avete qualcosa da offrire e qualcosa da guadagnare.',
  help_in_person_events_title: 'Ideale per fiere ed eventi',
  help_in_person_events_desc: "allarga il raggio per trovare collezionisti lontani con cui accordarsi prima dell'evento.",
  help_sections_title: "Le sezioni dell'app",
  help_section_discover_desc: "Naviga i profili dei collezionisti compatibili. Scorri a destra (Trade) per segnalare interesse, a sinistra (Swipe) per passare oltre. Vedi solo chi ha carte che cerchi e cerca carte che hai tu. Con l'abbonamento Pro puoi aprire i Filtri per restringere gli abbinamenti.",
  help_section_inventory_desc: 'Il tuo raccoglitore digitale. Aggiungi le carte da scambiare con condizione, lingua, grading e variante. Le carte impegnate in un match attivo risultano bloccate e non compaiono agli altri utenti.',
  help_section_wishlist_desc: 'Le carte che stai cercando. Più la wishlist è precisa (condizione, lingua, variante), migliori saranno i match proposti dal sistema.',
  help_section_matches_desc: 'Qui trovi i match che hai creato (Match inviati) e quelli che hai ricevuto (Match in arrivo). Chatta, seleziona le carte, invia o accetta la proposta di scambio finale.',
  help_section_profile_desc: "Modifica nome e posizione. Da qui accedi a Impostazioni (raggio, gioco predefinito, abbonamento Pro), allo Storico scambi completati e all'Assistenza.",
  help_swipe_title: 'Come funziona lo Swipe',
  help_swipe_desc: 'La sezione Scopri non mostra carte a caso. Il sistema applica un filtro bilaterale automatico prima di proporti qualsiasi profilo.',
  help_swipe_mutual_title: 'Compatibilità reciproca',
  help_swipe_mutual_desc: "vengono incrociati la tua wishlist con l'inventario degli altri e, in parallelo, la loro wishlist con il tuo inventario. Appare solo chi è utile per entrambi.",
  help_swipe_active_matches_title: 'Match in corso esclusi',
  help_swipe_active_matches_desc: "le carte già coinvolte in un match attivo non vengono mostrate nella vista Scopri. In questo modo devi scegliere bene se avviare il match o swipare passando all'abbinamento successivo.",
  help_swipe_radius_title: 'Raggio geografico',
  help_swipe_radius_desc: "vedi solo profili entro il raggio impostato nelle Impostazioni (100 km predefiniti nel piano Free). Puoi modificarlo in qualsiasi momento dall'icona in alto nella scheda Scopri.",
  help_swipe_pro_filters_title: 'Filtri Pro',
  help_swipe_pro_filters_desc: 'puoi restringere gli abbinamenti per rarità, condizione, lingua, casa di gradazione e voto. I filtri vengono salvati sul dispositivo e applicati alla ricerca successiva.',
  help_swipe_identity_title: 'Criteri di identità carta',
  help_swipe_identity_desc: 'il sistema tiene conto di carta, condizione, lingua, grading e variante per garantire la pertinenza degli abbinamenti.',
  help_match_title: 'Come funziona un Match',
  help_match_positive_title: 'Match positivo',
  help_match_positive_desc: 'fai match su un profilo compatibile; il match compare nella sezione Match inviati.',
  help_match_chat_title: 'Chat',
  help_match_chat_desc: 'accordatevi su quante e quali carte scambiare, dove e quando incontrarvi.',
  help_match_proposal_title: 'Proposta formale',
  help_match_proposal_desc: "chi ha avviato lo swipe seleziona le carte e invia la proposta; l'altro la accetta o rifiuta.",
  help_match_in_person_title: 'Scambio di persona',
  help_match_in_person_desc: 'vi incontrate, scambiate le carte a mano e il match viene chiuso.',
  help_match_note: 'Le carte incluse in una proposta in attesa risultano bloccate e non possono essere selezionate in altri match finché quella proposta non viene risolta.',
  help_pro_title: 'Perché diventare Pro?',
  help_pro_desc: 'SwipeWish Pro sblocca funzionalità avanzate pensate per chi scambia con frequenza, su distanze maggiori o con più giochi.',
  help_pro_radius_title: 'Raggio fino a 2000 km',
  help_pro_radius_desc: 'perfetto per eventi, fiere e convention fuori zona. Nel piano Free il limite è 100 km.',
  help_pro_slots_title: 'Slot inventario illimitati',
  help_pro_slots_desc: 'aggiungi tutte le carte che vuoi senza mai raggiungere il limite.',
  help_pro_three_way_title: 'Scambi tripli (A→B→C→A)',
  help_pro_three_way_desc: 'suggerimenti per chiudere trattative che altrimenti rimarrebbero in stallo per mancanza di interesse diretto.',
  help_pro_filters_title: 'Filtri avanzati in Scopri',
  help_pro_filters_desc: 'restringi la ricerca per rarità, condizione, lingua, casa di gradazione e voto direttamente dal pulsante Filtri.',
  help_pro_multi_tcg_title: 'Ricerca multi-TCG',
  help_pro_multi_tcg_desc: 'estendi la ricerca a tutti i giochi contemporaneamente, anche al di fuori del gioco predefinito. Quando è attiva, il filtro per rarità della carta viene azzerato e disattivato perché le rarità non sono uniformi tra giochi diversi.',
  help_pro_visibility_title: 'Maggiore visibilità',
  help_pro_visibility_desc: 'le tue carte appaiono prima nei risultati degli altri collezionisti, con badge Pro sul profilo.',
  help_pro_nearby_title: 'Alert scambio vicino in tempo reale',
  help_pro_nearby_desc: 'Ogni 5 minuti SwipeWish cerca scambi compatibili entro 1 km. Quando ne trova uno, riceverete entrambi una notifica: chi clicca per primo avvia lo scambio e diventa iniziatore. Se la controparte è Free e ha già 4 match attivi, non riceverà l\'alert. Richiede GPS attivo (anche in background) e notifiche push abilitate.',

  // --- Nearby trade alerts ---
  nearby_alert_title: 'Scambio vicino disponibile',
  nearby_alert_subtitle: '{user} a {distance} km · Tocca per avviare lo scambio',
  nearby_alert_section_title: 'Vicino a te',
  nearby_alert_claim_cta: 'Avvia scambio',
  nearby_alert_claim_error_already_claimed: 'Un altro utente ha già avviato questo scambio.',
  nearby_alert_claim_error_free_cap: 'Il limite di scambi attivi del piano Free è stato raggiunto per la controparte.',
  nearby_alert_push_title: 'Scambio vicino disponibile',
  nearby_alert_push_body: 'Tocca per avviare lo scambio.',
  bg_geo_title: 'SwipeWish',
  bg_geo_notice: 'Ti teniamo aggiornato sugli scambi vicini.',

  // --- Settings ---
  settings_title: 'Impostazioni',
  settings_language: 'Lingua',
  settings_language_it: 'Italiano',
  settings_language_en: 'English',
  settings_radius: 'Raggio di scambio',
  settings_radius_desc: 'Mostriamo solo carte entro {radius} km da te.',
  settings_radius_free: 'Il piano Free è limitato a 100 km.',
  settings_go_pro: 'Passa a SwipeWish Pro',
  settings_pro_desc: 'Raggio fino a 2000 km, slot illimitati e scambi tripli e tanto altro.',
  settings_three_way: 'Scambi tripli',
  settings_three_way_desc: 'Suggerimenti A -> B -> C -> A per chiudere stalli.',
  settings_pro_only: '(solo Pro)',
  settings_update_loc: 'Aggiorna posizione',
  settings_update_loc_desc: 'La tua posizione esatta non viene salvata, solo una approssimazione.',

  // --- Subscription ---
  sub_title: 'SwipeWish Pro',
  sub_price: '1,99',
  sub_period: '/mese',
  sub_subtitle: 'Sblocca ricerca avanzata, più raggio e strumenti per scambiare con precisione.',
  sub_already_pro: 'Sei già un utente Pro!',
  sub_pay_app_store: 'Abbonati con Apple App Store',
  sub_pay_app_store_loading: 'Apertura App Store',
  sub_pay_play_store: 'Abbonati con Google Play',
  sub_pay_play_store_loading: 'Apertura Google Play',
  sub_mobile_only_message: "L'acquisto Pro è disponibile solo da app mobile (iOS/Android) tramite store.",
  sub_store_redirected_notice: 'Ti stiamo reindirizzando allo store per completare il pagamento.',
  sub_store_error: 'Impossibile avviare il pagamento sullo store. Riprova.',
  sub_legal: 'Sottoscrivendo accetti i Termini di servizio. Puoi cancellare in qualsiasi momento dalle impostazioni del tuo store.',
  sub_renewal_notice: 'Abbonamento Pro mensile con rinnovo automatico ogni mese salvo annullamento prima del rinnovo.',
  sub_features: [
    'Raggio fino a 2000 km',
    'Alert scambio vicino (≤1 km) in tempo reale',
    'Slot inventario illimitati',
    'Filtri avanzati in Scopri: rarità, condizione, lingua, gradazione e voto',
    'Ricerca abbinamenti combinati su più TCG',
    'Boost di visibilità per le tue carte',
    'Suggerimenti scambi tripli (A -> B -> C -> A)',
    'Badge profilo Pro',
  ],

  // --- Three-way trades ---
  three_title: 'Scambi tripli',
  three_pro_gate_title: 'Funzione Pro',
  three_pro_gate_desc: 'I suggerimenti di scambi tripli (A -> B -> C -> A) sono disponibili solo per gli utenti Pro. Servono a chiudere trattative che altrimenti resterebbero in stallo.',
  three_intro: 'Suggerimenti di triangolazioni: <strong>tu</strong> dai una carta a <strong>B</strong>, B la dà a <strong>C</strong>, C ti chiude il cerchio.',
  three_empty_title: 'Nessun ciclo trovato',
  three_empty_desc: 'Al momento non ci sono triangolazioni vantaggiose nel tuo raggio. Aggiungi più carte alla wishlist e al binder per aumentare le chance!',
  three_propose: 'Proponi questo scambio',
  three_proposed: 'Scambio triplo proposto!',
  three_you: 'Tu',
  three_distances: 'Distanze: {d1}km + {d2}km',

  // --- Card condition ---
  cond_mint: 'M',
  cond_near_mint: 'NM',
  cond_excellent: 'EX',
  cond_good: 'GD',
  cond_light_played: 'LP',
  cond_played: 'PL',
  cond_poor: 'PO',

  // --- Barra filtri (Collezione / Wishlist) ---
  filter_name_placeholder: 'Nome carta',
  filter_number_placeholder: '#  Numero',
  filter_expansion_placeholder: 'Espansione',
  filter_results: '{count} di {total}',
  filter_no_results: 'Nessuna carta corrisponde alla ricerca',

  // --- Foglio modifica raggio (Scopri) ---
  swipe_more_cards: '{n} carte disponibili',
  swipe_details: 'Dettagli',
  swipe_details_count: 'carte',
  swipe_radius_title: 'Raggio di ricerca',
  swipe_radius_apply: 'Applica',
  swipe_radius_loading: 'Applicazione raggio e caricamento nuovi match…',
  swipe_radius_profile_save_failed: 'Raggio applicato ai risultati, ma salvataggio profilo non riuscito. Riprova.',

  // --- Impostazioni: aggiorna indirizzo ---
  settings_update_address_desc: 'Modifica la posizione usata per calcolare le distanze.',
  settings_address_saved: 'Indirizzo aggiornato',

  // --- Impostazioni: gioco predefinito ---
  settings_default_game: 'Gioco predefinito',
  settings_default_game_desc: 'Pre-seleziona il filtro gioco nella Collezione e nella Wishlist.',
  settings_default_game_none: 'Tutti i giochi',

  // --- Onboarding ---
  onboarding_skip: 'Salta',
  onboarding_next: 'Avanti',
  onboarding_start: 'Inizia',
  onboarding_slide1_title: 'Scambia di persona',
  onboarding_slide1_desc: 'SwipeWish mette in contatto collezionisti di carte TCG nella tua zona. Niente spedizioni, niente rischi: trovi chi ha le tue carte, vi accordate e vi incontrate di persona.',
  onboarding_slide2_title: 'La tua Collezione',
  onboarding_slide2_desc: 'Nella scheda Collezione aggiungi le carte che vuoi scambiare. Le carte già impegnate in un match attivo vengono bloccate automaticamente e non compaiono ad altri utenti.',
  onboarding_slide3_title: 'La tua Wishlist',
  onboarding_slide3_desc: 'Aggiungi in Wishlist le carte che cerchi. Il sistema ti propone solo utenti con cui esiste interesse reciproco: tu hai almeno una loro carta e loro hanno almeno una delle tue.',
  onboarding_slide4_title: 'Match e accordati',
  onboarding_slide4_desc: 'Quando fai swipe positivo su un profilo compatibile scatta il Match! Vai nella scheda Match, chatta per accordarti e scambiate le carte di persona — sicuro e senza intermediari.',
  onboarding_slide5_title: 'Trova collezionisti vicini',
  onboarding_slide5_desc: 'Attiva il GPS per scoprire carte nelle vicinanze. Regola il raggio di ricerca nelle Impostazioni: il piano Pro lo estende fino a 2000 km. La tua posizione esatta non viene mai salvata.',

  // --- Swipe stamps ---
  stamp_like: 'MATCH',
  stamp_nope: 'SWIPE',
  stamp_in_wishlist: 'Nella tua wishlist',

  // --- Location source ---
  location_source_gps: 'GPS attivo',
  location_source_address: 'Posizione da indirizzo profilo',
  settings_address_geo_hint: 'Verrà usato solo se la geolocalizzazione del dispositivo non è disponibile.',

  // --- Catalog: condition selector ---
  catalog_condition_label: 'Condizione',
  catalog_language_label: 'Lingua',
  catalog_grading_company_label: 'Gradazione',
  catalog_grading_company_none: 'Nessuna',
  catalog_grade_label: 'Voto',
  catalog_grade_placeholder: 'Seleziona',
  catalog_price_label: 'Prezzo',
  catalog_notes_label: 'Note',
  catalog_notes_placeholder: 'stamped, firmata ecc',

  matches_delete: 'Elimina',
  matches_send_trade: 'Invia scambio',
  matches_waiting_acceptance: 'In attesa',
  matches_accept_trade: 'Accetta scambio',

  // --- Support ---
  profile_support: 'Assistenza',
  support_title: 'Assistenza',
  support_subject_label: 'Oggetto',
  support_subject_placeholder: 'Descrivi brevemente il problema',
  support_description_label: 'Descrizione',
  support_description_placeholder: 'Inserisci tutti i dettagli utili...',
  support_send: 'Invia email',

  // --- Match notifications ---
  matches_trade_sent: 'Proposta inviata!',
  matches_trade_accepted: 'Scambio accettato!',
  matches_match_deleted: 'Match eliminato',
  details_unavailable_section: 'Carte non disponibili',
  details_available_section: 'Carte disponibili',
  details_unavailable_committed_badge: 'Le carte non disponibili sono già impegnate in un altro match.',
  details_traded_section: 'Carte scambiate',
  details_not_traded_section: 'Carte non scambiate',
  matches_details_validation_loading: 'Verifica disponibilità carte…',
  matches_trade_block_my_inventory: 'Una o più carte che stai offrendo sono già impegnate in un\'altra proposta in attesa: non hai abbastanza copie disponibili.',
  matches_trade_block_peer_inventory: 'L\'altro utente sta già offrendo una delle carte richieste in un\'altra proposta in attesa. Riprova più tardi.',
  matches_trade_block_initiator_inventory: 'L\'utente che ti ha inviato la proposta non ha più copie sufficienti: ha già impegnato la carta in un\'altra proposta in attesa.',
  matches_trade_block_wishlist: 'Hai già un\'altra proposta in attesa che ti consegna questa carta: accettare supererebbe la quantità in wishlist.',
  matches_trade_block_no_valid_cards: 'Non puoi inviare la proposta: non ci sono quantità valide disponibili nelle carte selezionabili.',
  matches_no_available_cards: 'Non ci sono carte disponibili',
  matches_chat_hint: 'Per chattare con l\'utente premere sul match interessato.',

  // --- Pro tier / Multi-TCG / History ---
  profile_pro_status_active: 'Abbonamento Pro attivo',
  profile_go_pro_badge: 'Diventa Pro',
  settings_multi_tcg_matching: 'Ricerca abbinamenti combinati',
  settings_multi_tcg_desc: 'Estende la ricerca degli abbinamenti a tutti i TCG. Il filtro Rarità viene disattivato finché questa opzione resta attiva.',
  settings_multi_tcg_pro_only: "L'opzione è attivabile solo con l'abbonamento Pro.",
  settings_pro_membership_title: 'Abbonamento Pro',
  settings_pro_expiry_value: 'Scadenza: {date}',
  settings_pro_expiry_unknown: 'Data non disponibile',
  settings_pro_cancel_btn: 'Annulla abbonamento',
  settings_pro_cancel_scheduled: 'Annullamento già pianificato a fine periodo.',
  settings_pro_cancel_confirm_title: 'Conferma annullamento',
  settings_pro_cancel_confirm_message: 'Il piano Pro resterà attivo fino al {date}. Vuoi continuare?',
  settings_pro_cancel_success_title: 'Annullamento pianificato',
  settings_pro_cancel_success_message: 'Il tuo abbonamento verrà annullato a fine periodo.',
  settings_pro_cancel_failed_message: 'Impossibile annullare l\'abbonamento. Riprova.',
  settings_pro_cancel_manual_title: 'Gestione annullamento esterna',
  settings_pro_cancel_manual_message: 'Per abbonamenti gestiti da store esterni (Apple/Google/PayPal) annulla direttamente dal relativo account.',
  history_title: 'Storico scambi',
  history_empty: 'Nessuno scambio concluso.',
  history_unavailable_card_label: 'Carta non più disponibile',

  // --- Details modal ---
  details_readonly_info: 'La modifica alle quantità è disponibile solo in fase di proposta e solo da chi ha avviato lo scambio.',
  details_proposal_sent_info: 'Proposta inviata, le quantità non sono più modificabili.',
  details_offer: 'Offri',
  details_obtain: 'Ottieni',
  details_request: 'Chiedi',
  details_select_all: 'Seleziona tutte',
  details_deselect_all: 'Deseleziona tutte',

  // --- Landing page ---
  landing_header_features: 'Funzionalità',
  landing_header_how_it_works: 'Come funziona',
  landing_header_download: 'Download',
  landing_header_login: 'Accedi',
  landing_hero_badge: 'Disponibile su Android',
  landing_hero_title: 'Scambia',
  landing_hero_title_accent: 'carte vicino a te',
  landing_hero_desc: 'Aggiungi le carte che hai e quelle che vuoi, sfoglia le collezioni degli utenti vicini e proponi uno scambio in pochi tap.',
  landing_hero_download_btn: 'Scarica per Android',
  landing_hero_ios_btn: 'App Store — Prossimamente',
  landing_hero_footnote: 'Gratis · Senza pubblicità · Nessun abbonamento',
  landing_features_label: 'Funzionalità',
  landing_features_title: 'Tutto quello che ti serve',
  landing_features_title_accent: 'per scambiare carte',
  landing_features_desc: 'SwipeWish TCG mette in contatto collezionisti vicini a te e rende gli scambi semplici e sicuri.',
  landing_feature_swipe_title: 'Match per desideri',
  landing_feature_swipe_desc: 'Il sistema abbina automaticamente le tue wishlist con le collezioni di chi ti sta vicino.',
  landing_feature_nearby_title: 'Solo vicino a te',
  landing_feature_nearby_desc: 'Gli scambi avvengono in presenza. Il raggio di ricerca è impostabile da 1 a 2000 km.',
  landing_feature_realtime_title: 'Notifiche in tempo reale',
  landing_feature_realtime_desc: 'Ricevi subito una notifica quando qualcuno vuole scambiare con te.',
  landing_feature_multi_title: 'Multi TCG',
  landing_feature_multi_desc: 'Pokémon, Magic, One Piece e altri giochi di carte su un\'unica piattaforma.',
  landing_how_label: 'Come funziona',
  landing_how_title: 'Tre passi',
  landing_how_title_accent: 'per lo scambio perfetto',
  landing_how_add_title: 'Aggiungi alla tua collezione e alla tua wishlist',
  landing_how_add_desc: 'Scansiona o cerca le carte che possiedi e quelle nella tua wishlist.',
  landing_how_find_title: 'Trova un match',
  landing_how_find_desc: 'Sfoglia le carte degli utenti vicini: fai un match o passa avanti.',
  landing_how_close_title: 'Chiudi lo scambio',
  landing_how_close_desc: 'Accordatevi sul luogo di incontro tramite chat e scambiate le carte di persona.',
  landing_download_label: 'Download',
  landing_download_title: 'Inizia a scambiare',
  landing_download_title_accent: 'oggi stesso',
  landing_download_desc: 'Scarica l\'app gratuitamente e inizia a trovare scambi vicino a te.',
  landing_download_android_req: 'Android 8.0+',
  landing_download_android_status: 'Disponibile',
  landing_download_android_desc: 'Installa il file APK direttamente, senza bisogno del Play Store. Aggiornamenti automatici in-app.',
  landing_download_android_btn: 'Scarica APK',
  landing_download_free: 'Gratis',
  landing_download_no_ads: 'Senza pubblicità',
  landing_download_updates: 'Aggiornamenti gratuiti',
  landing_download_ios_req: 'iOS 16+',
  landing_download_ios_status: 'Prossimamente',
  landing_download_ios_desc: 'La versione iOS è in sviluppo attivo. Iscriviti alla lista d\'attesa per essere il primo a provarla.',
  landing_download_ios_hint: 'Vuoi essere avvisato?',
  landing_download_ios_contact: 'Contattaci',
  landing_modal_aria: 'Download SwipeWish TCG',
  landing_modal_close: 'Chiudi',
  landing_modal_title: 'Download per Android',
  landing_modal_subtitle: 'File APK · Aggiornamenti in-app',
  landing_modal_download_btn: 'Scarica APK',
  landing_modal_downloading: 'Download in corso...',
  landing_modal_downloaded: 'Download completato',
  landing_modal_download_error: 'Download non riuscito. Verifica che il file APK sia pubblicato correttamente e riprova.',
  landing_modal_how_to_install: 'Come installare',
  landing_modal_step1_title: 'Apri il file scaricato',
  landing_modal_step1_desc: 'Trova il file APK nella cartella Download del tuo dispositivo.',
  landing_modal_step2_title: 'Consenti origini sconosciute',
  landing_modal_step2_desc: 'Nelle impostazioni, abilita <em>"Installa app da fonti sconosciute"</em>.',
  landing_modal_step3_title: 'Installa l\'app',
  landing_modal_step3_desc: 'Segui le istruzioni di installazione sullo schermo.',
  landing_modal_step4_title: 'Aprila e registrati',
  landing_modal_step4_desc: 'Crea il tuo account e inizia a cercare scambi vicino a te.',
  landing_modal_safety: 'File sicuro, verificato dal team SwipeWish.',
  landing_footer_tagline: 'La piattaforma di scambio carte TCG per collezionisti.',
  landing_footer_nav_aria: 'Navigazione footer',
  landing_footer_app_section: 'App',
  landing_footer_features: 'Funzionalità',
  landing_footer_how_it_works: 'Come funziona',
  landing_footer_download_android: 'Scarica per Android',
  landing_footer_support_section: 'Supporto',
  landing_footer_contact: 'Contattaci',
  landing_footer_webapp: 'Accedi alla Web App',
  landing_footer_legal_section: 'Legale',
  landing_footer_privacy: 'Privacy Policy',
  landing_footer_terms: 'Termini di servizio',
  landing_footer_copyright: '© {year} SwipeWish TCG. Tutti i diritti riservati.',
  landing_footer_made: 'Fatto con ♥ per i collezionisti',
} as const;


